/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, Stack, SxProps, Typography, useTheme } from "@mui/material";
import React from "react";

import { EditButton } from "../../products/components/ProductCard/EditButton";
import { SeedMix } from "../types/SeedOrderFormType";

import SeedOrderDeliveryDetails from "./SeedOrderDeliveryDetails";

export const FulfillmentButton = ({
  openAddress,
  seedMix,
  sx,
}: {
  // control: Control<SeedOrdersInfo>
  openAddress: () => void;
  seedMix: SeedMix;
  sx: SxProps;
}) => {
  // const seed = useWatch({ name: `mixes.${seedIndex}`, control })
  const seed = seedMix;
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
      onClick={openAddress}
      padding="8px"
      width="100%"
      bgcolor={theme.colors.primary200}
      borderRadius="8px"
      sx={{
        "&:hover": {
          cursor: "pointer",
        },
        ...sx,
      }}
    >
      <Box display="flex" flexDirection="column">
        <SeedOrderDeliveryDetails seed={seed} />
        {seed?.deliveryInstructions ? (
          <Stack direction="row" spacing={1}>
            <Typography variant="body2" fontWeight="bold" color={theme.colors.primary500}>
              Delivery instructions:
            </Typography>
            <Typography variant="body2" color={theme.colors.primary500}>
              {seed?.deliveryInstructions}
            </Typography>
          </Stack>
        ) : null}
      </Box>
      <EditButton onClick={openAddress} sx={{ flexWrap: "nowrap" }} />
    </Box>
  );
};
